import { defineMessages } from 'react-intl';

/* eslint-disable max-len */
export default defineMessages({
  defaultMessage: {
    id: 'components.error.defaultMessage',
    defaultMessage: 'An error occurred, please try again later',
  },
  LOGIN_CHARS: {
    id: 'components.error.LOGIN_CHARS',
    defaultMessage: 'Login should start with a Latin letter, contain only Latin characters, numbers, a sign. Length is at least 4 characters',
  },
  PASSWORD_NOT_8_CHARS: {
    id: 'components.error.PASSWORD_NOT_8_CHARS',
    defaultMessage: 'Password must be at least 8 characters',
  },
  PASSWORD_NOT_LOWCASE: {
    id: 'components.error.PASSWORD_NOT_LOWCASE',
    defaultMessage: 'The password must contain at least one Latin character in the lower case',
  },
  PASSWORD_NOT_UPERCASE: {
    id: 'components.error.PASSWORD_NOT_UPERCASE',
    defaultMessage: 'The password must contain at least one Latin character in uppercase',
  },
  PASSWORD_NOT_DIGIT: {
    id: 'components.error.PASSWORD_NOT_DIGIT',
    defaultMessage: 'Password must contain at least one digit',
  },
  WRONG_LOGIN: {
    id: 'components.error.WRONG_LOGIN',
    defaultMessage: 'Wrong login or password',
  },
  UNCONFIRMED_LOGIN: {
    id: 'components.error.UNCONFIRMED_LOGIN',
    defaultMessage: 'Login still not confirmed',
  },
  LOGIN_ALREADY_EXISTS: {
    id: 'components.error.LOGIN_ALREADY_EXISTS',
    defaultMessage: 'Login already exist',
  },
  EMAIL_ALREADY_EXISTS: {
    id: 'components.error.EMAIL_ALREADY_EXISTS',
    defaultMessage: 'Email already exist',
  },
  INVALID_EMAIL: {
    id: 'components.error.INVALID_EMAIL',
    defaultMessage: 'Invalid email',
  },
  REGISTRATION: {
    id: 'components.error.REGISTRATION',
    defaultMessage: 'Registration error',
  },
  DB_ERROR: {
    id: 'components.error.DB_ERROR',
    defaultMessage: 'Database error',
  },
  WRONG_AUTORIZATION_CODE: {
    id: 'components.error.WRONG_AUTORIZATION_CODE',
    defaultMessage: 'Wrong authorization code',
  },
  LOGIN_NOT_FOUNDED: {
    id: 'components.error.LOGIN_NOT_FOUNDED',
    defaultMessage: 'Login not founded',
  },
  CONFIRM_CODE_NOT_FOUNDED: {
    id: 'components.error.CONFIRM_CODE_NOT_FOUNDED',
    defaultMessage: 'Confirm code not founded',
  },
  LOGOUT_ERROR: {
    id: 'components.error.LOGOUT_ERROR',
    defaultMessage: 'Logout error',
  },
  NO_ACCESS: {
    id: 'components.error.NO_ACCESS',
    defaultMessage: 'Access forbiden',
  },
  WEBMASTER_NOT_FOUND: {
    id: 'components.error.WEBMASTER_NOT_FOUND',
    defaultMessage: 'Webmaster not founded',
  },
  WEBMASTER_INFO_NOT_FOUND: {
    id: 'components.error.WEBMASTER_INFO_NOT_FOUND',
    defaultMessage: 'Webmaster info not founded',
  },
  PARTNER_INFO_NOT_FOUND: {
    id: 'components.error.PARTNER_INFO_NOT_FOUND',
    defaultMessage: 'Partner info not founded',
  },
  AUTH_REQUIRED: {
    id: 'components.error.AUTH_REQUIRED',
    defaultMessage: 'Authentication required',
  },
  AUTH_PARTNER_REQUIRED: {
    id: 'components.error.AUTH_PARTNER_REQUIRED',
    defaultMessage: 'Authentication required for partner',
  },
  AUTH_WEBMASTER_REQUIRED: {
    id: 'components.error.AUTH_WEBMASTER_REQUIRED',
    defaultMessage: 'Authentication required for webmaster',
  },
  SEND_EMAIL_ERROR: {
    id: 'components.error.SEND_EMAIL_ERROR',
    defaultMessage: 'Send email error',
  },
  LIMIT_RESTRICTION: {
    id: 'components.error.LIMIT_RESTRICTION',
    defaultMessage: 'Limit restriction',
  },
  BAD_PARAM_PARAM: {
    id: 'components.error.BAD_PARAM_PARAM',
    defaultMessage: 'Parameter %s is absent or invalid format',
  },
});



// WEBPACK FOOTER //
// ./src/components/Error/messages.js